import script from "./DotMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./DotMenu.vue?vue&type=script&lang=ts&setup=true"

import "./DotMenu.vue?vue&type=style&index=0&id=90bc5eac&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90bc5eac"]])

export default __exports__